(function() {
  'use strict';

  angular
    .module('quiz.labelingPicture')
    .directive('lpAnswer', LpAnswer);

  LpAnswer.$inject = ['$window'];

  function LpAnswer($window) {
    var directive = {
      scope: {
        lpAnswer: '<',
        lpAnswerAssociatedimageid: '@',
        lpAnswerDragdisabled: '<'
      },
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, element, attr, ctrl) {
      var associatedImageId;
      var answer;
      var newOffset;

      element.draggable({
        containment: '#labelPicture',
        zIndex: 100,
        scroll: true,
        revert: 'invalid',
        refreshPositions: true
      });

      scope.$watch('lpAnswer', onAnswer);
      scope.$watch('lpAnswerAssociatedimageid', onAssociatedImageId);
      scope.$watch('lpAnswerDragdisabled', onDragDisabled);

      angular.element($window).on('resize', setLabelPostions);

      function setLabelPostions() {
        if (associatedImageId) {
          newOffset = angular.element('#' + associatedImageId).offset();
          element.stop(true).offset(newOffset);
          return;
        }

        element.stop(true).animate({
          top: 0,
          left: 0
        }, 1000);
      }

      function onAnswer(value) {
        answer = value;
      }

      function onAssociatedImageId(value) {
        associatedImageId = value;
        setLabelPostions();
      }

      function onDragDisabled(value) {
        element.draggable('option', 'disabled', value);
      }
    }
  }
})();
